import type { FunctionComponent } from "react";

import { SCMPPlusTabs } from "scmp-app/components/scmp-plus-tabs";

import { Container, Wrapper } from "./styles";

export type Props = {
  className?: string;
};

export const NavigationBar: FunctionComponent<Props> = ({ className }) => (
  <Container className={className}>
    <Wrapper>
      <SCMPPlusTabs isPlus={true} />
    </Wrapper>
  </Container>
);

NavigationBar.displayName = "NavigationBar";
